import { computed, type ComputedRef } from "vue";
import { useAuthStore } from "@/store/Auth";

import { useI18n } from "vue-i18n";

export interface Label {
  "counseling-archive": string;
  home: string;
  "counselor-list": string;
  mattermost: string;
}

export function useNavigationLabels() {
  const { t } = useI18n();

  const authStore = useAuthStore();

  const isTenantAdmin = computed(() => {
    return authStore.isTenantAdmin;
  });

  /**
   * These labels get used by the breadcrum too, so the names
   * have to be equal to the route name
   */
  const labels: ComputedRef<Label> = computed(() => {
    return {
      "counseling-archive": consultationArchiveLabel.value,
      home: consultationsLinkLabel.value,
      "counselor-list": counselorListLabel.value,
      mattermost: mattermostLabel.value,
    };
  });

  const consultationsLinkLabel = computed(() => {
    return (
      isTenantAdmin.value
        ? t("navigation.allCounselings")
        : t("navigation.myCounselings")
    ).toString();
  });

  const consultationArchiveLabel = computed((): string => {
    return t("navigation.counselingArchive").toString();
  });

  const counselorListLabel = computed((): string => {
    return t("navigation.counselorList").toString();
  });

  const mattermostLabel = computed((): string => {
    return t("general.mattermost").toString();
  });

  return { labels, consultationsLinkLabel };
}
